import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  RealtimeKitComponentsModule,
  RtkMeeting,
} from '@cloudflare/realtimekit-angular-ui';
import { State } from '../../../shared/core/state';
import { Store } from '@ngrx/store';

import * as AppConfigActions from '../../../shared/core/state/config/config.action';
import { LiveClassService } from '../../../shared/core/state/live-class/live-class.service';
import { catchError, EMPTY, mergeMap } from 'rxjs';
import { ToastService } from '@black/ui';
import RTKBridge from '../../../../native-plugins/RTKBridge';
import { ActivatedRoute } from '@angular/router';
import { PluginListenerHandle } from '@capacitor/core';

@Component({
  selector: 'black-dyte-meeting',
  templateUrl: './dyte-meeting.component.html',
  styleUrls: ['./dyte-meeting.component.css'],
  standalone: true,
  imports: [RealtimeKitComponentsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DyteMeetingComponent implements AfterViewInit, OnInit, OnDestroy {
  private store = inject<Store<State>>(Store);
  private meetingService = inject(LiveClassService);
  private route = inject(ActivatedRoute);
  private toastService = inject(ToastService);

  title = 'default-meeting-ui';
  @ViewChild('meet') $meetingEl!: RtkMeeting;

  @ViewChild('meetingContainer') $meetingContainer!: ElementRef;

  showErrorScreen = false;
  private meetingEndedListener?: PluginListenerHandle;

  ngOnInit(): void {
    this.store.dispatch(AppConfigActions.hideHeader());
    this.store.dispatch(AppConfigActions.hideMobileDock());
  }

  ngOnDestroy(): void {
    this.store.dispatch(AppConfigActions.showHeader());
    this.store.dispatch(AppConfigActions.showMobileDock());
    this.$meetingEl.meeting.leave();
    this.meetingEndedListener?.remove();
  }

  enterFullScreen(): void {
    const element = this.$meetingContainer.nativeElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if ((element as any).webkitRequestFullscreen) {
      (element as any).webkitRequestFullscreen();
    } else if ((element as any).msRequestFullscreen) {
      (element as any).msRequestFullscreen();
    } else {
      console.warn('Fullscreen API is not supported in this browser.');
    }
  }

  async ngAfterViewInit() {
    const shareLinkId = this.route.snapshot.paramMap.get('meetingId');

    if (!shareLinkId) {
      this.toastService.showToast('Invalid Share Link Id!', 'error');
      return;
    }

    this.meetingService
      .getRealtimeKitMeeting(shareLinkId)
      .pipe(
        mergeMap((meetingData) => {
          const meetingId =
            meetingData.rtkMeetingId || meetingData.dyteMeetingId;
          if (!meetingId) {
            return EMPTY;
          }
          return this.meetingService.getRealtimeKitToken(meetingId);
        }),
        catchError((err) => {
          console.error('error', err);
          this.showErrorScreen = true;
          return EMPTY;
        }),
      )
      .subscribe(async (tokenData) => {
        const authToken = tokenData.token;

        if (!authToken) {
          this.toastService.showToast('Invalid token!', 'error');
          return;
        }

        this.meetingEndedListener = await RTKBridge.addListener(
          'meetingEnded',
          () => {
            setTimeout(() => {
              window.close();
            }, 2000);
          },
        );

        await RTKBridge.initialize({
          authToken,
          enableAudio: true,
          enableVideo: true,
        });

        // Start the meeting UI
        await RTKBridge.startMeeting();
      });
  }

  // FEAT: Improve the meeting security

  // Allow users to only join within the meeting period [Restrict out of the hour meeting] - Optional
  // Check if user have active subscription with this meeting - [DONE]
  // Auto kick-out users who stays more then meeting time - Optional
  // Show a countdown until meeting starts - [TODO]
}
